import type { AuthResponse } from '@conversia/shared-types';
import { api } from './client';

/**
 * Registro de un cliente nuevo. `crear-cuenta` es pública; el resto
 * (/api/alta/*) es de la cuenta recién creada, que todavía no tiene negocio.
 */

export type EstadoDeAlta = 'BORRADOR' | 'ENVIADA' | 'APROBADA' | 'RECHAZADA';

export interface Hallazgo {
  problema: string;
  solucion: string;
  modulos: string[];
  /** Lo que dijo el cliente, tal cual. */
  frase: string;
}

export interface Analisis {
  resumen: string;
  hallazgos: Hallazgo[];
  modulos: string[];
}

export interface AudioDeAlta {
  mime: string;
  bytes: number;
  transcripcion: string | null;
  creadoEn: string;
}

export interface MiSolicitud {
  id: string;
  negocioNombre: string;
  textoCliente: string;
  estado: EstadoDeAlta;
  motivoRechazo: string | null;
  audios: AudioDeAlta[];
  modulosPropuestos: string[];
  analisis: Analisis | null;
}

export interface ModuloOfrecido {
  id: string;
  nombre: string;
  descripcion: string;
}

export type ResultadoDelAnalisis =
  | { disponible: false; motivo: string }
  | { disponible: true; analisis: Analisis; solicitud: MiSolicitud };

export const crearCuenta = (input: { nombre: string; negocio: string; email: string; password: string }) =>
  api.post<AuthResponse>('/api/auth/crear-cuenta', input, { skipAuth: true });

export const miSolicitud = () => api.get<MiSolicitud>('/api/alta/mi-solicitud');

export const catalogo = () =>
  api.get<{ items: ModuloOfrecido[] }>('/api/alta/catalogo').then((r) => r.items);

export const guardarTexto = (texto: string) => api.post<MiSolicitud>('/api/alta/texto', { texto });

export function subirAudio(audio: Blob, nombre: string) {
  const form = new FormData();
  form.append('audio', audio, nombre);
  return api.post<{ solicitud: MiSolicitud; transcrito: boolean; mensaje: string }>('/api/alta/audio', form);
}

export const analizar = () => api.post<ResultadoDelAnalisis>('/api/alta/analizar');

export const enviar = (modulos: string[]) => api.post<MiSolicitud>('/api/alta/enviar', { modulos });
